(function () {
  'use strict';

  var LIMIT = 8;
  var ACTIVE_CLASS = 'mx-search-active';
  var SEARCH_CACHE = new Map();
  var PRODUCT_CACHE = null;
  var timers = new WeakMap();
  var controllers = new WeakMap();
  var activeQuery = new WeakMap();
  var activeForm = null;
  var floatingBox = null;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cleanText(value) {
    return String(value || '')
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function rootUrl() {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) root = Shopify.routes.root;
    if (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.root) {
      root = window.MinimogSettings.routes.root;
    }
    root = String(root || '/');
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function route(name, fallback) {
    if (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes[name]) {
      return window.MinimogSettings.routes[name];
    }
    return fallback;
  }

  function absolute(path) {
    return new URL(String(path || '/'), window.location.origin);
  }

  function searchBase(form) {
    return (form && form.getAttribute('data-mx-search-url')) || route('search_url', rootUrl() + 'search');
  }

  function suggestBase(form) {
    return (form && form.getAttribute('data-mx-suggest-url')) || route('predictive_search_url', rootUrl() + 'search/suggest');
  }

  function buildSearchUrl(form, query) {
    var url = absolute(searchBase(form));
    url.searchParams.set('q', query || '');
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    return url.pathname + url.search;
  }

  function buildSuggestJsonUrl(form, query) {
    var base = String(suggestBase(form) || (rootUrl() + 'search/suggest'));
    base = base.replace(/\.json(\?.*)?$/, '');
    var url = absolute(base + '.json');
    url.searchParams.set('q', query || '');
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', String(LIMIT));
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    return url.toString();
  }

  function buildSuggestSectionUrl(form, query) {
    var url = absolute(suggestBase(form));
    url.searchParams.set('q', query || '');
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', String(LIMIT));
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('section_id', 'predictive-search');
    return url.toString();
  }

  function buildSearchSectionUrl(form, query) {
    var url = absolute(searchBase(form));
    url.searchParams.set('q', query || '');
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    url.searchParams.set('section_id', 'main');
    return url.toString();
  }

  function productsJsonUrl() {
    var url = absolute(rootUrl() + 'products.json');
    url.searchParams.set('limit', '250');
    return url.toString();
  }

  function normalizeUrl(url) {
    url = String(url || '').trim();
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) {
      try { return new URL(url).pathname + new URL(url).search; } catch (e) { return url; }
    }
    return url.charAt(0) === '/' ? url : '/' + url.replace(/^\/+/, '');
  }

  function imgUrl(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (value.url) return value.url;
    if (value.src) return value.src;
    if (value.preview_image) return imgUrl(value.preview_image);
    if (value.featured_image) return imgUrl(value.featured_image);
    return '';
  }

  function normalizePrice(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'object') value = value.amount || value.value || value.price || '';
    value = cleanText(value);
    if (!value) return '';
    if (/^[0-9]+(\.[0-9]{1,2})?$/.test(value)) return '£' + value;
    return value;
  }

  function normalizeProduct(product) {
    if (!product) return null;
    var title = cleanText(product.title || product.name);
    var handleUrl = product.handle ? (rootUrl() + 'products/' + product.handle) : '';
    var url = normalizeUrl(product.url || handleUrl);
    var image = imgUrl(product.image || product.featured_image || product.featured_media || (product.images && product.images[0]));
    var price = normalizePrice(product.price || product.price_min || product.price_max || (product.variants && product.variants[0] && product.variants[0].price));
    if (!title || !url || url.indexOf('/products/') === -1) return null;
    return { title: title, url: url, image: image, price: price };
  }

  function uniqueProducts(products) {
    var seen = {};
    var output = [];
    (Array.isArray(products) ? products : []).forEach(function (product) {
      product = normalizeProduct(product);
      if (!product || seen[product.url]) return;
      seen[product.url] = true;
      output.push(product);
    });
    return output.slice(0, LIMIT);
  }

  function titleFromCard(card, link) {
    var titleEl = card && card.querySelector('.m-search-item--title, .m-product-card__name, .m-product-card__title a, .m-product-card__title, .m-predictive-search__item-heading, [data-product-title]');
    var title = cleanText(titleEl ? titleEl.textContent : '');
    if (!title && link) title = cleanText(link.getAttribute('aria-label') || link.getAttribute('title') || link.textContent);
    if (!title && card) {
      var img = card.querySelector('img');
      title = cleanText(img && img.getAttribute('alt'));
    }
    return title;
  }

  function imageFromCard(card) {
    var img = card && card.querySelector('img');
    if (!img) return '';
    return img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-original') || '';
  }

  function priceFromCard(card) {
    var priceEl = card && card.querySelector('.m-search-item--price, .m-product-card__price, .m-price, [class*="price"]');
    return cleanText(priceEl ? priceEl.textContent : '');
  }

  function addLinkProduct(products, seen, link) {
    if (!link) return;
    var href = normalizeUrl(link.getAttribute('href'));
    if (!href || href.indexOf('/products/') === -1 || seen[href]) return;
    var card = link.closest('.m-search-item, .m-product-card, li, article, [data-product-id]') || link;
    var title = titleFromCard(card, link);
    if (!title || /^(add to cart|quick view|view all|sold out)$/i.test(title)) return;
    seen[href] = true;
    products.push({ title: title, url: href, image: imageFromCard(card), price: priceFromCard(card) });
  }

  function parseProductsFromHtml(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var products = [];
    var seen = {};
    doc.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      addLinkProduct(products, seen, link);
    });
    return uniqueProducts(products);
  }

  function productMatches(product, query) {
    query = String(query || '').toLowerCase();
    var parts = query.split(/\s+/).filter(Boolean);
    var haystack = [
      product.title,
      product.handle,
      product.product_type,
      product.vendor,
      Array.isArray(product.tags) ? product.tags.join(' ') : product.tags,
      Array.isArray(product.variants) ? product.variants.map(function (variant) {
        return [variant.title, variant.sku, variant.option1, variant.option2, variant.option3].join(' ');
      }).join(' ') : ''
    ].join(' ').toLowerCase();
    return parts.every(function (part) { return haystack.indexOf(part) !== -1; });
  }

  function fetchJson(url, signal) {
    return fetch(url, { signal: signal, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('json ' + response.status);
        return response.json();
      });
  }

  function fetchText(url, signal) {
    return fetch(url, { signal: signal, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('html ' + response.status);
        return response.text();
      });
  }

  function fetchPredictiveJson(form, query, signal) {
    return fetchJson(buildSuggestJsonUrl(form, query), signal).then(function (data) {
      var products = data && data.resources && data.resources.results && data.resources.results.products;
      return uniqueProducts(products || []);
    });
  }

  function fetchPredictiveHtml(form, query, signal) {
    return fetchText(buildSuggestSectionUrl(form, query), signal).then(parseProductsFromHtml);
  }

  function fetchSearchHtml(form, query, signal) {
    return fetchText(buildSearchSectionUrl(form, query), signal).then(parseProductsFromHtml);
  }

  function fetchProductsJson(query, signal) {
    if (PRODUCT_CACHE) {
      return Promise.resolve(uniqueProducts(PRODUCT_CACHE.filter(function (product) { return productMatches(product, query); })));
    }
    return fetchJson(productsJsonUrl(), signal).then(function (data) {
      PRODUCT_CACHE = Array.isArray(data && data.products) ? data.products : [];
      return uniqueProducts(PRODUCT_CACHE.filter(function (product) { return productMatches(product, query); }));
    });
  }

  function getResultsBox(form) {
    return form ? form.querySelector('[data-mx-search-results]') : null;
  }

  function ensureFloatingBox() {
    if (floatingBox && document.body.contains(floatingBox)) return floatingBox;
    floatingBox = document.createElement('div');
    floatingBox.className = 'mx-floating-search-results';
    floatingBox.setAttribute('role', 'listbox');
    floatingBox.setAttribute('aria-live', 'polite');
    floatingBox.style.display = 'none';
    document.body.appendChild(floatingBox);
    return floatingBox;
  }

  function positionFloatingBox(form) {
    if (!form || !floatingBox || floatingBox.style.display === 'none') return;
    var rect = form.getBoundingClientRect();
    var isMobile = form.hasAttribute('data-mx-mobile-search') || window.innerWidth < 1024;
    var gap = isMobile ? 8 : 10;
    var top = Math.round(rect.bottom + gap);

    floatingBox.style.top = top + 'px';
    floatingBox.style.maxHeight = Math.max(180, window.innerHeight - top - 14) + 'px';

    if (isMobile) {
      floatingBox.style.left = '10px';
      floatingBox.style.right = '10px';
      floatingBox.style.width = 'auto';
    } else {
      var width = Math.max(330, Math.min(430, Math.max(rect.width, 360)));
      var left = Math.min(window.innerWidth - width - 14, Math.max(14, rect.right - width));
      floatingBox.style.left = Math.round(left) + 'px';
      floatingBox.style.right = 'auto';
      floatingBox.style.width = Math.round(width) + 'px';
    }
  }

  function showFloating(form, html) {
    var box = ensureFloatingBox();
    activeForm = form;
    box.innerHTML = html;
    box.style.display = 'block';
    window.requestAnimationFrame(function () {
      positionFloatingBox(form);
      box.classList.add('is-visible');
    });
  }

  function hideFloating(form) {
    if (!floatingBox) return;
    if (form && activeForm && form !== activeForm) return;
    floatingBox.classList.remove('is-visible');
    floatingBox.innerHTML = '';
    floatingBox.style.display = 'none';
    activeForm = null;
  }

  function closeMega() {
    document.querySelectorAll('m-header').forEach(function (header) {
      header.classList.remove('m-mega-active', 'slide-from-right', 'slide-reveal');
      header.classList.add(ACTIVE_CLASS);
    });
    document.querySelectorAll('.m-menu__item--active').forEach(function (item) {
      item.classList.remove('m-menu__item--active');
    });
  }

  function setExpanded(form, expanded) {
    if (!form || !form.hasAttribute('data-mx-mobile-search')) return;
    var header = form.closest('.m-header__mobile');
    var input = form.querySelector('input[name="q"]');
    var button = form.querySelector('button[type="submit"]');
    form.classList.toggle('is-expanded', !!expanded);
    form.classList.add('is-animating');
    window.clearTimeout(form._mxAnimTimer);
    form._mxAnimTimer = window.setTimeout(function () { form.classList.remove('is-animating'); }, 560);
    if (header) header.classList.toggle('mx-search-expanded', !!expanded);
    if (button) button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    document.documentElement.classList.toggle('mx-mobile-search-open', !!expanded);
    document.body && document.body.classList.toggle('mx-mobile-search-open', !!expanded);
    if (expanded && input) {
      window.clearTimeout(form._mxFocusTimer);
      form._mxFocusTimer = window.setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
        positionFloatingBox(form);
      }, 360);
    } else if (!expanded) {
      hideResults(form);
    }
  }

  function setInternalBox(form, html) {
    var box = getResultsBox(form);
    if (box) box.innerHTML = html;
  }

  function hideResults(form) {
    if (!form) return;
    form.classList.remove('mx-search-loading', 'mx-search-has-results', 'mx-search-error');
    form.setAttribute('aria-busy', 'false');
    setInternalBox(form, '');
    hideFloating(form);
  }

  function statusHtml(message) {
    return '<div class="mx-search-status">' + escapeHtml(message) + '</div>';
  }

  function showStatus(form, message, isError) {
    var html = statusHtml(message);
    form.classList.add('mx-search-has-results');
    form.classList.toggle('mx-search-error', !!isError);
    setInternalBox(form, html);
    showFloating(form, html);
  }

  function renderResultsHtml(form, query, products) {
    products = uniqueProducts(products);
    if (!products.length) {
      return '<div class="mx-search-status">No products found</div>' +
        '<a class="mx-search-view-all" href="' + escapeHtml(buildSearchUrl(form, query)) + '">Search all products</a>';
    }
    return '<div class="mx-search-result-list">' + products.map(function (product) {
      return '<a class="mx-search-result-item" href="' + escapeHtml(product.url) + '">' +
        '<span class="mx-search-result-img">' +
          (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span class="mx-search-result-img-fallback"></span>') +
        '</span>' +
        '<span class="mx-search-result-text">' +
          '<span class="mx-search-result-title">' + escapeHtml(product.title) + '</span>' +
          (product.price ? '<span class="mx-search-result-meta">' + escapeHtml(product.price) + '</span>' : '') +
        '</span>' +
      '</a>';
    }).join('') + '</div>' +
      '<a class="mx-search-view-all" href="' + escapeHtml(buildSearchUrl(form, query)) + '">View all matching products</a>';
  }

  function renderResults(form, query, products) {
    if (activeQuery.get(form) !== query) return;
    var html = renderResultsHtml(form, query, products);
    form.classList.remove('mx-search-loading', 'mx-search-error');
    form.classList.add('mx-search-has-results');
    form.setAttribute('aria-busy', 'false');
    setInternalBox(form, html);
    showFloating(form, html);
  }

  function requestResults(form, query) {
    var key = query.toLowerCase();
    if (SEARCH_CACHE.has(key)) {
      renderResults(form, query, SEARCH_CACHE.get(key));
      return;
    }

    var oldController = controllers.get(form);
    if (oldController && oldController.abort) oldController.abort();
    var controller = window.AbortController ? new AbortController() : null;
    controllers.set(form, controller || {});
    var signal = controller ? controller.signal : undefined;

    form.classList.add('mx-search-loading', 'mx-search-has-results');
    form.classList.remove('mx-search-error');
    form.setAttribute('aria-busy', 'true');
    showStatus(form, 'Searching...');

    fetchPredictiveJson(form, query, signal)
      .catch(function () { return []; })
      .then(function (products) { return products.length ? products : fetchPredictiveHtml(form, query, signal).catch(function () { return []; }); })
      .then(function (products) { return products.length ? products : fetchSearchHtml(form, query, signal).catch(function () { return []; }); })
      .then(function (products) { return products.length ? products : fetchProductsJson(query, signal).catch(function () { return []; }); })
      .then(function (products) {
        SEARCH_CACHE.set(key, products || []);
        renderResults(form, query, products || []);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        form.classList.remove('mx-search-loading');
        form.setAttribute('aria-busy', 'false');
        showStatus(form, 'Press enter to search', true);
      });
  }

  function queueResults(form) {
    var input = form && form.querySelector('input[name="q"]');
    if (!input) return;
    var query = String(input.value || '').trim();
    activeQuery.set(form, query);
    window.clearTimeout(timers.get(form));
    if (!query) {
      hideResults(form);
      return;
    }
    timers.set(form, window.setTimeout(function () {
      if (activeQuery.get(form) !== query) return;
      requestResults(form, query);
    }, 160));
  }

  function ensureHiddenInputs(form) {
    var values = {
      'type': 'product',
      'options[prefix]': 'last',
      'options[unavailable_products]': 'last'
    };
    Object.keys(values).forEach(function (name) {
      var input = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = values[name];
    });
  }

  function bind(form) {
    if (!form || form.dataset.mxAjaxBound === 'true') return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    form.classList.add('mx-use-floating');
    form.setAttribute('autocomplete', 'off');
    form.setAttribute('aria-busy', 'false');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    ensureHiddenInputs(form);

    form.addEventListener('pointerdown', function () {
      closeMega();
      if (form.hasAttribute('data-mx-mobile-search') && !form.classList.contains('is-expanded')) setExpanded(form, true);
    }, true);

    form.addEventListener('focusin', function () {
      closeMega();
      if (form.hasAttribute('data-mx-mobile-search')) setExpanded(form, true);
      queueResults(form);
    });

    input.addEventListener('input', function () { queueResults(form); });
    input.addEventListener('keyup', function () { queueResults(form); });
    input.addEventListener('search', function () { queueResults(form); });
    input.addEventListener('paste', function () { window.setTimeout(function () { queueResults(form); }, 0); });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        hideResults(form);
        if (form.hasAttribute('data-mx-mobile-search')) setExpanded(form, false);
        input.blur();
      }
    });

    form.addEventListener('submit', function (event) {
      closeMega();
      var query = String(input.value || '').trim();
      input.value = query;
      ensureHiddenInputs(form);
      if (form.hasAttribute('data-mx-mobile-search') && !form.classList.contains('is-expanded')) {
        event.preventDefault();
        setExpanded(form, true);
        return false;
      }
      if (!query) {
        event.preventDefault();
        setExpanded(form, true);
        hideResults(form);
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
        return false;
      }
    });

    form.dataset.mxAjaxBound = 'true';
  }

  function init(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-mx-ajax-search]')).forEach(bind);
  }

  document.addEventListener('click', function (event) {
    var insideForm = event.target.closest && event.target.closest('[data-mx-ajax-search]');
    var insideFloat = event.target.closest && event.target.closest('.mx-floating-search-results');
    if (insideForm || insideFloat) return;
    document.querySelectorAll('[data-mx-ajax-search]').forEach(function (form) {
      hideResults(form);
      if (form.hasAttribute('data-mx-mobile-search')) setExpanded(form, false);
    });
    document.querySelectorAll('m-header').forEach(function (header) { header.classList.remove(ACTIVE_CLASS); });
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mx-ajax-search]').forEach(function (form) {
      hideResults(form);
      if (form.hasAttribute('data-mx-mobile-search')) setExpanded(form, false);
    });
    document.querySelectorAll('m-header').forEach(function (header) { header.classList.remove(ACTIVE_CLASS); });
  });

  var mxPositionFrame = null;
  function scheduleFloatingPosition() {
    if (!activeForm || mxPositionFrame) return;
    mxPositionFrame = window.requestAnimationFrame(function () {
      mxPositionFrame = null;
      positionFloatingBox(activeForm);
    });
  }
  window.addEventListener('resize', scheduleFloatingPosition, { passive: true });
  window.addEventListener('scroll', scheduleFloatingPosition, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();
